module.exports = __webpack_public_path__ + "fa-regular-400.625dca125b58060788da05a5cf42c30c.hashedasset.ttf";